import CollectiveCanvasLogo from "@/assets/logos/CollectiveCanvasLogo";
import { Center } from "@mantine/core";
import type { ReactNode } from "react";

interface CanvasLegalPageProps {
  children: ReactNode;
}

export function CanvasLegalPage({ children }: CanvasLegalPageProps) {
  return (
    <>
      <Center pt="xl" pb="sm">
        <CollectiveCanvasLogo color="var(--text-on-dark)" size="md" scaleFactor={1.1} />
      </Center>
      {children}
    </>
  );
}
